import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import moment from "moment";

const getInitials = (user) => {
  if (!user) return '';
  const first = user.firstName?.trim()?.[0] || '';
  const last = user.lastName?.trim()?.[0] || '';
  return (first + last).toUpperCase();
};

const SentDetail = ({ selectedEmail }) => {
  const [showAllTo, setShowAllTo] = useState(false);
  const [showAllCC, setShowAllCC] = useState(false);

  if (!selectedEmail) return null;

  const formatDate = (timestamp) => moment(timestamp).format("ddd DD/MM/YYYY HH:mm");
  const lightColors = ['#F5E388', '#D3F9D8', '#E0F7FA', '#FFF9C4', '#F8BBD0'];

  const getRandomLightColor = () => {
    return lightColors[Math.floor(Math.random() * lightColors.length)];
  };

  return (
    <Grid item xs={12} sm={12} md={7}>
      <Paper style={{ padding: '16px', height: '100%' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              {selectedEmail.emailSubject}
            </Typography>

            <div style={{
              borderTop: '1px solid grey',
              borderBottom: '1px solid grey',
              padding: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              marginBottom: '8px'
            }}>
              <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 16 }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      backgroundColor: getRandomLightColor(),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#000',
                      fontWeight: 'bold',
                      fontSize: 16,
                      marginRight: 8,
                    }}
                  >
                    {getInitials(selectedEmail.fromUser)}
                  </div>
                </div>

                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Typography variant="body2" color="textPrimary">
                    {`${selectedEmail.fromUser.firstName || ''} ${selectedEmail.fromUser.lastName || ''} <${selectedEmail.fromUser.email || ''}>`}
                  </Typography>

                  <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1 }}>
                     
                      {selectedEmail?.toUser?.length > 0 && (
                        <Typography variant="body2" color="textSecondary">
                          <span style={{ color: 'black' }}>To:</span>{' '}
                          {selectedEmail.toUser
                            .slice(0, showAllTo ? selectedEmail.toUser.length : 2)
                            .map((user, index, array) => (
                              <span key={user.email}>
                                {user.email}
                                {index < array.length - 1 ? ', ' : ''}
                              </span>
                            ))}
                          {!showAllTo && selectedEmail.toUser.length > 2 && (
                            <span>
                              ,{' '}
                              <span
                                style={{ color: '#3f51b5', cursor: 'pointer' }}
                                onClick={() => setShowAllTo(true)}
                              >
                                +{selectedEmail.toUser.length - 2}
                              </span>
                            </span>
                          )}
                          {showAllTo && selectedEmail.toUser.length > 2 && (
                            <span
                              style={{
                                marginLeft: 8,
                                color: '#3f51b5',
                                cursor: 'pointer',
                                fontSize: '0.875rem',
                              }}
                              onClick={() => setShowAllTo(false)}
                            >
                              Show less
                            </span>
                          )}
                        </Typography>
                      )}

                     
                      {selectedEmail?.ccUser?.length > 0 && (
                        <Typography variant="body2" color="textSecondary" style={{ paddingTop: '10px' }}>
                          <span style={{ color: 'black' }}>Cc:</span>{' '}
                          {selectedEmail.ccUser
                            .slice(0, showAllCC ? selectedEmail.ccUser.length : 2)
                            .map((user, index, array) => (
                              <span key={user.email}>
                                {user.email}
                                {index < array.length - 1 ? ', ' : ''}
                              </span>
                            ))}
                          {!showAllCC && selectedEmail.ccUser.length > 2 && (
                            <span>
                              ,{' '}
                              <span
                                style={{ color: '#3f51b5', cursor: 'pointer' }}
                                onClick={() => setShowAllCC(true)}
                              >
                                +{selectedEmail.ccUser.length - 2}
                              </span>
                            </span>
                          )}
                          {showAllCC && selectedEmail.ccUser.length > 2 && (
                            <span
                              style={{
                                marginLeft: 8,
                                color: '#3f51b5',
                                cursor: 'pointer',
                                fontSize: '0.875rem',
                              }}
                              onClick={() => setShowAllCC(false)}
                            >
                              Show less
                            </span>
                          )}
                        </Typography>
                      )}
                    </div>

                    <Typography variant="body2" color="textSecondary">
                      {formatDate(selectedEmail.timeStamp)}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>

            <Typography variant="body1" style={{ whiteSpace: 'pre-line', paddingTop: '10px' }}>
              {selectedEmail?.emailBody && (
                <div
                  style={{ width: '100%', height: '100%' }}
                  dangerouslySetInnerHTML={{ __html: selectedEmail.emailBody }}
                ></div>
              )}
            </Typography>
          </div>
        </div>
      </Paper>
    </Grid> 
  );
};

export default SentDetail;
